<div class="main-container ac-table-page">
  <header class="title">
    <span class="title-text">Platform Reports</span>
    <p class="small-title">Every establishment at a glance, plus who has access to what.</p>
  </header>
  <div class="tabs-row">
    <div class="ac-tabs">
      @for(tab of reportTabs; track tab.key){
      <button type="button" class="ac-tab" [class.active]="activeReport === tab.key" (click)="setReport(tab.key)">
        {{ tab.label }}
      </button>
      }
    </div>
  </div>
  @if(usesEstablishmentFilter){
  <div class="filter-bar">
    <div class="each-div">
      <label class="drop-title" id="pr-est-label">Establishment</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-est-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="establishment" (selectionChange)="onEstablishmentChange()">
          <mat-option [value]="''">All establishments</mat-option>
          @for(e of establishments; track e.establishmentId){
          <mat-option [value]="e.establishmentId">{{ e.name }}</mat-option>
          }
        </mat-select>
      </mat-form-field>
    </div>
    @if(activeReport === 'funnel' && establishment.value){
    <div class="each-div">
      <label class="drop-title" id="pr-utsav-label">Utsav</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-utsav-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="utsav" (selectionChange)="loadReport()">
          <mat-option [value]="''">All utsavs</mat-option>
          @for(u of utsavs; track u.utsavId){ <mat-option [value]="u.utsavId">{{ u.name }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    }
    @if(usesDateRange){
    <div class="each-div">
      <label class="drop-title" for="pr-from">From</label>
      <input id="pr-from" type="date" class="text-box-active" [formControl]="fromDate"
        (change)="applyActivityFilters()" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="pr-to">To</label>
      <input id="pr-to" type="date" class="text-box-active" [formControl]="toDate" (change)="applyActivityFilters()" />
    </div>
    }
    @if(activeReport === 'utsavs'){
    <div class="each-div">
      <label class="drop-title" id="pr-active-label">Utsav status</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-active-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="activeOnly" (selectionChange)="loadReport()">
          <mat-option value="true">Active only</mat-option>
          <mat-option value="false">All</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    }
  </div>
  }
  @if(activeReport === 'activity'){
  <form class="filter-bar" (submit)="applyActivityFilters($event)">
    <div class="each-div">
      <label class="drop-title" for="pr-act-from">From</label>
      <input id="pr-act-from" type="date" class="text-box-active" [formControl]="fromDate" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="pr-act-to">To</label>
      <input id="pr-act-to" type="date" class="text-box-active" [formControl]="toDate" />
    </div>
    <div class="each-div">
      <label class="drop-title" for="pr-act-user">User</label>
      <input id="pr-act-user" type="text" class="text-box-active" placeholder="Username" [formControl]="actUser" />
    </div>
    <div class="each-div">
      <label class="drop-title" id="pr-act-module-label">Module</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-act-module-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="actModule">
          <mat-option [value]="''">All</mat-option>
          @for(m of report?.modules || []; track m.module){ <mat-option [value]="m.module">{{ m.module }} ({{ m.calls
            }})</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" id="pr-act-method-label">Method</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-act-method-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="actMethod">
          <mat-option [value]="''">All</mat-option>
          @for(m of ['GET','POST','PUT','PATCH','DELETE']; track m){ <mat-option [value]="m">{{ m }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
    <div class="each-div">
      <label class="drop-title" id="pr-act-fail-label">Outcome</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-act-fail-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="actFailures">
          <mat-option [value]="''">All</mat-option>
          <mat-option value="true">Failures only</mat-option>
        </mat-select>
      </mat-form-field>
    </div>
    <div class="filter-actions">
      <button type="submit" class="ac-primary-btn" [disabled]="isLoading">Apply</button>
    </div>
  </form>
  }
  @if(report){
  <div class="table-toolbar">
    <button type="button" class="ac-secondary-btn export-btn" [disabled]="isLoading" (click)="exportCsv()">Export
      CSV</button>
  </div>
  }
  @if(!isLoading && !report){
  <div class="empty-state">
    {{ reportLoadFailed ? 'The report could not be loaded. Please try again.' : 'No data is available.' }}
  </div>
  }

  <!-- ===== Establishments ===== -->

  @if(report && activeReport === 'establishments'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Establishments</span><span class="count-value">{{
        report.totals?.establishments ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Properties</span><span class="count-value">{{
        report.totals?.properties ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Rooms</span><span class="count-value">{{ report.totals?.rooms ?? 0
        }}</span></div>
    <div class="count-card"><span class="count-label">Bed capacity</span><span class="count-value">{{
        report.totals?.capacity ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Active utsavs</span><span class="count-value">{{
        report.totals?.activeUtsavs ?? 0 }}<span class="count-unit"> / {{ report.totals?.utsavs ?? 0 }}</span></span>
    </div>
    <div class="count-card"><span class="count-label">Live bookings</span><span class="count-value">{{
        report.totals?.bookings ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Guests booked</span><span class="count-value">{{
        report.totals?.guests ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Beds occupied now</span><span class="count-value">{{
        report.totals?.occupiedBeds ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Staff</span><span class="count-value">{{ report.totals?.staff ?? 0
        }}</span></div>
  </div>
  <span class="report-note">Live bookings exclude cancelled and rejected. Beds occupied = active allocations of
    checked-in
    bookings. Staff = users holding an establishment role there.</span>
  <div class="report-table-container ac-table-region" role="region" aria-label="Establishments" tabindex="0">
    <table class="occupancy-table wide-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Establishment</th>
          <th scope="col" class="num-col">Properties</th>
          <th scope="col" class="num-col">Rooms</th>
          <th scope="col" class="num-col">Capacity</th>
          <th scope="col" class="num-col">Utsavs (active)</th>
          <th scope="col" class="num-col">Live bookings</th>
          <th scope="col" class="num-col">Guests</th>
          <th scope="col" class="num-col">Checked-in</th>
          <th scope="col" class="pct-col">Occupied now</th>
          <th scope="col" class="text-col">Staff</th>
        </tr>
      </thead>
      <tbody>
        @for(row of report.rows; track row.establishmentId){
        <tr [class.inactive]="!row.isActive">
          <td class="text-col" data-label="Establishment">
            <span class="cell-title">{{ row.name }}</span>
            <span class="muted"> {{ row.code }}@if(!row.isActive){ · inactive}</span>
          </td>
          <td class="num-col" data-label="Properties">{{ row.properties }}</td>
          <td class="num-col" data-label="Rooms">{{ row.rooms }}</td>
          <td class="num-col" data-label="Capacity">{{ row.capacity }}</td>
          <td class="num-col" data-label="Utsavs (active)">{{ row.activeUtsavs }} / {{ row.utsavs }}</td>
          <td class="num-col" data-label="Live bookings">{{ row.bookings }}</td>
          <td class="num-col" data-label="Guests">{{ row.guests }}</td>
          <td class="num-col" data-label="Checked-in">{{ row.checkedIn }}</td>
          <td class="pct-col" data-label="Occupied now">
            <div class="pct-cell">
              <div class="pct-bar">
                <div class="pct-fill" [class.full]="row.occupancyPct >= 100"
                  [style.width.%]="row.occupancyPct > 100 ? 100 : row.occupancyPct"></div>
              </div>
              <span>{{ row.occupiedBeds }} / {{ row.capacity }} ({{ row.occupancyPct }}%)</span>
            </div>
          </td>
          <td class="text-col staff-cell" data-label="Staff">
            <span class="staff-count">{{ row.staff }}</span>
            @if(row.staff){
            <span class="muted staff-details">{{ staffLabel(row) }}</span>
            }
          </td>
        </tr>
        } @empty {
        <tr>
          <td colspan="10" class="empty-row">No establishments.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
  <!-- ===== Utsavs ===== -->
  @if(report && activeReport === 'utsavs'){
  <span class="report-note">Assigned = beds of the rooms allocated to the utsav. Held = beds of live bookings (assigned
    or
    occupied). Target comes from the utsav's capacity target.</span>
  <div class="report-table-container ac-table-region" role="region" aria-label="Utsavs" tabindex="0">
    <table class="occupancy-table wide-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Utsav</th>
          <th scope="col" class="text-col">Establishment</th>
          <th scope="col" class="text-col">Utsav dates</th>
          <th scope="col" class="text-col">Accommodation</th>
          <th scope="col" class="num-col">Target</th>
          <th scope="col" class="num-col">Assigned</th>
          <th scope="col" class="pct-col">Held</th>
          <th scope="col" class="num-col">Pending</th>
          <th scope="col" class="num-col">Assigned bookings</th>
          <th scope="col" class="num-col">Confirmed</th>
          <th scope="col" class="num-col">Checked-in</th>
          <th scope="col" class="num-col">Checked-out</th>
          <th scope="col" class="num-col">Cancelled</th>
          <th scope="col" class="num-col">Guests</th>
        </tr>
      </thead>
      <tbody>
        @for(u of report.rows; track u.utsavId){
        <tr [class.inactive]="!u.isActive">
          <td class="text-col" data-label="Utsav"><span class="cell-title">{{ u.name }}</span> <span class="muted">{{
              u.utsavCode }}@if(!u.isActive){ · inactive}</span></td>
          <td class="text-col" data-label="Establishment">{{ u.establishmentName || ('#' + u.establishmentId) }}</td>
          <td class="text-col" data-label="Utsav dates">{{ u.utsavStartDate || '—' }} → {{ u.utsavEndDate || '—' }}</td>
          <td class="text-col" data-label="Accommodation">{{ u.accommodationStartDate || '—' }} → {{
            u.accommodationEndDate || '—' }}</td>
          <td class="num-col" data-label="Target">{{ u.targetCapacity ?? '—' }}</td>
          <td class="num-col" data-label="Assigned">{{ u.assigned?.total ?? 0 }}</td>
          <td class="pct-col" data-label="Held">
            <div class="pct-cell">
              <div class="pct-bar">
                <div class="pct-fill" [class.full]="u.heldPct >= 100"
                  [style.width.%]="u.heldPct > 100 ? 100 : u.heldPct"></div>
              </div>
              <span>{{ u.heldBeds }} ({{ u.heldPct }}%)</span>
            </div>
          </td>
          <td class="num-col" data-label="Pending">{{ u.bookings?.pending ?? 0 }}</td>
          <td class="num-col" data-label="Assigned bookings">{{ u.bookings?.assigned ?? 0 }}</td>
          <td class="num-col" data-label="Confirmed">{{ u.bookings?.confirmed ?? 0 }}</td>
          <td class="num-col" data-label="Checked-in">{{ u.bookings?.checkedIn ?? 0 }}</td>
          <td class="num-col" data-label="Checked-out">{{ u.bookings?.checkedOut ?? 0 }}</td>
          <td class="num-col" data-label="Cancelled">{{ (u.bookings?.cancelled ?? 0) + (u.bookings?.rejected ?? 0) }}
          </td>
          <td class="num-col" data-label="Guests">{{ u.bookings?.guests ?? 0 }}</td>
        </tr>
        } @empty {
        <tr>
          <td colspan="14" class="empty-row">No utsavs match the filters.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  }
  <!-- ===== Activity log ===== -->
  @if(report && activeReport === 'activity'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">API calls</span><span class="count-value">{{
        report.totals?.calls ?? 0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.failures ?? 0) > 0"><span
        class="count-label">Failures</span><span class="count-value">{{ report.totals?.failures ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Distinct users</span><span class="count-value">{{
        report.totals?.users ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Avg response</span><span class="count-value">{{
        report.totals?.avgMs ?? '—' }}<span class="count-unit"> ms</span></span></div>
    <div class="count-card"><span class="count-label">p95 response</span><span class="count-value">{{
        report.totals?.p95Ms ?? '—' }}<span class="count-unit"> ms</span></span></div>
  </div>
  <p class="report-note">{{ report.from }} to {{ report.to }} · management app calls only (sam_service_logs, channel
    MANAGEMENT). Times are IST. Request and response bodies are not shown here.</p>
  <div class="composition-grid">
    <div>
      <h2 class="section-title">Top endpoints</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Top endpoints" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">Endpoint</th>
              <th scope="col" class="num-col">Calls</th>
              <th scope="col" class="num-col">Failures</th>
              <th scope="col" class="num-col">Avg ms</th>
            </tr>
          </thead>
          <tbody>
            @for(e of report.topEndpoints; track $index){
            <tr>
              <td class="text-col mono" data-label="Endpoint">{{ e.method }} {{ e.endpoint }}</td>
              <td class="num-col" data-label="Calls">{{ e.calls }}</td>
              <td class="num-col" data-label="Failures" [class.warn]="e.failures > 0">{{ e.failures }}</td>
              <td class="num-col" data-label="Avg ms">{{ e.avgMs ?? '—' }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="4" class="empty-row">No calls in this range.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <h2 class="section-title">Top failing endpoints</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Failing endpoints" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">Endpoint</th>
              <th scope="col" class="num-col">Failures</th>
            </tr>
          </thead>
          <tbody>
            @for(e of report.failingEndpoints; track $index){
            <tr class="warn-row">
              <td class="text-col mono" data-label="Endpoint">{{ e.method }} {{ e.endpoint }}</td>
              <td class="num-col" data-label="Failures">{{ e.calls }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="2" class="empty-row">No failures.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <h2 class="section-title">Calls per user per day</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Calls per user per day" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Date</th>
          <th scope="col" class="text-col">User</th>
          <th scope="col" class="num-col">Calls</th>
          <th scope="col" class="num-col">Failures</th>
        </tr>
      </thead>
      <tbody>
        @for(r of report.byUserDay; track $index){
        <tr>
          <td class="text-col" data-label="Date">{{ r.date }}</td>
          <td class="text-col" data-label="User">{{ r.user }}</td>
          <td class="num-col" data-label="Calls">{{ r.calls }}</td>
          <td class="num-col" data-label="Failures" [class.warn]="r.failures > 0">{{ r.failures }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="4" class="empty-row">No calls in this range.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  <h2 class="section-title">Calls <span class="muted">({{ report.total }} · page {{ report.page }} of {{ activityPages
      }})</span></h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Activity rows" tabindex="0">
    <table class="occupancy-table wide-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">When (IST)</th>
          <th scope="col" class="text-col">User</th>
          <th scope="col" class="text-col">Method</th>
          <th scope="col" class="text-col">Path</th>
          <th scope="col" class="num-col">Status</th>
          <th scope="col" class="num-col">ms</th>
        </tr>
      </thead>
      <tbody>
        @for(r of report.rows; track r.id){
        <tr [class.warn-row]="!r.success">
          <td class="text-col" data-label="When">{{ r.at }}</td>
          <td class="text-col" data-label="User">{{ r.user }}</td>
          <td class="text-col mono" data-label="Method">{{ r.method }}</td>
          <td class="text-col mono path-col" data-label="Path">{{ r.path }}</td>
          <td class="num-col" data-label="Status">{{ r.success ? 'OK' : 'Failed' }}</td>
          <td class="num-col" data-label="ms">{{ r.ms }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="6" class="empty-row">No calls match the filters.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  @if(activityPages > 1){
  <div class="pager">
    <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading || report.page <= 1"
      (click)="goToPage(report.page - 1)">Previous</button>
    <span class="muted">Page {{ report.page }} of {{ activityPages }}</span>
    <button type="button" class="ac-secondary-small-btn" [disabled]="isLoading || report.page >= activityPages"
      (click)="goToPage(report.page + 1)">Next</button>
  </div>
  }
  }
  <!-- ===== Front-desk activity (all branches) ===== -->
  @if(report && activeReport === 'frontdesk'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Check-ins</span><span class="count-value">{{
        report.totals?.checkins ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Check-outs</span><span class="count-value">{{
        report.totals?.checkouts ?? 0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.late ?? 0) > 0"><span class="count-label">Late
        arrivals</span><span class="count-value">{{ report.totals?.late ?? 0 }}</span></div>
  </div>
  <p class="report-note">{{ report.from }} to {{ report.to }} · from the check-in / check-out stamps (only actions made
    after the stamps were introduced are counted). Arrival delay = check-in date minus booked from-date.</p>
  <div class="report-table-container ac-table-region" role="region" aria-label="Front-desk activity per establishment"
    tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Establishment</th>
          <th scope="col" class="num-col">Check-ins</th>
          <th scope="col" class="num-col">Check-outs</th>
          <th scope="col" class="num-col">Late arrivals</th>
          <th scope="col" class="num-col">Avg delay (days)</th>
        </tr>
      </thead>
      <tbody>
        @for(r of report.rows; track r.establishmentId){
        <tr [class.quiet-row]="!r.checkins && !r.checkouts">
          <td class="text-col" data-label="Establishment"><span class="cell-title">{{ r.name }}</span> <span
              class="muted">{{ r.code }}</span></td>
          <td class="num-col" data-label="Check-ins">{{ r.checkins }}</td>
          <td class="num-col" data-label="Check-outs">{{ r.checkouts }}</td>
          <td class="num-col" data-label="Late arrivals" [class.warn]="r.late > 0">{{ r.late }}</td>
          <td class="num-col" data-label="Avg delay (days)">{{ r.avgDelayDays ?? '—' }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="5" class="empty-row">No establishments.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  <h2 class="section-title">Operators</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Front-desk operators" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Operator</th>
          <th scope="col" class="text-col">Establishment</th>
          <th scope="col" class="num-col">Check-ins</th>
          <th scope="col" class="num-col">Check-outs</th>
        </tr>
      </thead>
      <tbody>
        @for(o of report.operators; track $index){
        <tr>
          <td class="text-col" data-label="Operator">{{ o.operator }}</td>
          <td class="text-col" data-label="Establishment">{{ o.establishmentName }}</td>
          <td class="num-col" data-label="Check-ins">{{ o.checkins }}</td>
          <td class="num-col" data-label="Check-outs">{{ o.checkouts }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="4" class="empty-row">No front-desk activity in this range.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  }
  <!-- ===== Bookings & cancellations (all branches) ===== -->
  @if(report && activeReport === 'funnel'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Bookings</span><span class="count-value">{{
        report.totals?.total ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Pending</span><span class="count-value">{{ report.totals?.pending
        ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Assigned</span><span class="count-value">{{
        report.totals?.assigned ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Confirmed</span><span class="count-value">{{
        report.totals?.confirmed ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Checked-in</span><span class="count-value">{{
        report.totals?.checkedIn ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Checked-out</span><span class="count-value">{{
        report.totals?.checkedOut ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Cancelled / rejected</span><span class="count-value">{{
        (report.totals?.cancelled ?? 0) + (report.totals?.rejected ?? 0) }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.heldBedAnomalies ?? 0) > 0"><span class="count-label">Beds
        held by dropped bookings</span><span class="count-value">{{ report.totals?.heldBedAnomalies ?? 0 }}</span></div>
  </div>
  <p class="report-note">Guests count live bookings only. "Beds held by dropped bookings" should be zero — anything else
    is a bed still allocated to a cancelled or rejected booking.</p>
  <div class="report-table-container ac-table-region" role="region" aria-label="Bookings per establishment"
    tabindex="0">
    <table class="occupancy-table wide-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Establishment</th>
          <th scope="col" class="num-col">Total</th>
          <th scope="col" class="num-col">Pending</th>
          <th scope="col" class="num-col">Assigned</th>
          <th scope="col" class="num-col">Confirmed</th>
          <th scope="col" class="num-col">Checked-in</th>
          <th scope="col" class="num-col">Checked-out</th>
          <th scope="col" class="num-col">Cancelled</th>
          <th scope="col" class="num-col">Rejected</th>
          <th scope="col" class="pct-col">Drop rate</th>
          <th scope="col" class="num-col">Guests</th>
          <th scope="col" class="num-col">Held beds (dropped)</th>
          <th scope="col" class="text-col">Top reasons</th>
        </tr>
      </thead>
      <tbody>
        @for(r of report.rows; track r.establishmentId){
        <tr [class.quiet-row]="!r.total">
          <td class="text-col" data-label="Establishment"><span class="cell-title">{{ r.name }}</span> <span
              class="muted">{{ r.code }}</span></td>
          <td class="num-col" data-label="Total">{{ r.total }}</td>
          <td class="num-col" data-label="Pending">{{ r.pending }}</td>
          <td class="num-col" data-label="Assigned">{{ r.assigned }}</td>
          <td class="num-col" data-label="Confirmed">{{ r.confirmed }}</td>
          <td class="num-col" data-label="Checked-in">{{ r.checkedIn }}</td>
          <td class="num-col" data-label="Checked-out">{{ r.checkedOut }}</td>
          <td class="num-col" data-label="Cancelled">{{ r.cancelled }}</td>
          <td class="num-col" data-label="Rejected">{{ r.rejected }}</td>
          <td class="pct-col" data-label="Drop rate">
            <div class="pct-cell">
              <div class="pct-bar">
                <div class="pct-fill" [class.full]="r.cancelPct >= 50" [style.width.%]="r.cancelPct"></div>
              </div>
              <span>{{ r.cancelPct }}%</span>
            </div>
          </td>
          <td class="num-col" data-label="Guests">{{ r.guests }}</td>
          <td class="num-col" data-label="Held beds (dropped)" [class.warn]="r.heldBedAnomalies > 0">{{
            r.heldBedAnomalies }}</td>
          <td class="text-col reason-col" data-label="Top reasons">
            @for(x of r.topReasons; track $index){ <span class="muted">{{ x.reason }} ({{ x.count
              }})</span>@if(!$last){<span class="muted">; </span>} } @empty { <span class="muted">—</span> }
          </td>
        </tr>
        } @empty { <tr>
          <td colspan="13" class="empty-row">No establishments.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  <h2 class="section-title">Cancellation reasons</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Cancellation reasons" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Reason</th>
          <th scope="col" class="num-col">Bookings</th>
        </tr>
      </thead>
      <tbody>
        @for(x of report.reasons; track $index){
        <tr>
          <td class="text-col reason-col" data-label="Reason">{{ x.reason }}</td>
          <td class="num-col" data-label="Bookings">{{ x.count }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="2" class="empty-row">No cancellations.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  }
  <!-- ===== Role drift ===== -->
  @if(activeReport === 'roleDrift'){
  <div class="filter-bar">
    <div class="each-div">
      <label class="drop-title" id="pr-drift-role-label">Role</label>
      <mat-form-field class="ac-select-field" appearance="outline" subscriptSizing="dynamic">
        <mat-select aria-labelledby="pr-drift-role-label" panelClass="ac-select-panel" [disableOptionCentering]="true"
          [formControl]="driftRole" (selectionChange)="loadReport()">
          <mat-option [value]="''">All roles</mat-option>
          @for(role of report?.roles || []; track role.roleId){ <mat-option [value]="role.roleId">{{ role.roleName
            }}</mat-option> }
        </mat-select>
      </mat-form-field>
    </div>
  </div>
  }
  @if(report && activeReport === 'roleDrift'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Roles</span><span class="count-value">{{
        report.totals?.roles ?? 0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.driftedAssignments ?? 0) > 0"><span
        class="count-label">Drifted assignments</span><span class="count-value">{{ report.totals?.driftedAssignments ??
        0 }}</span></div>
    <div class="count-card"><span class="count-label">Missing template pairs</span><span class="count-value">{{
        report.totals?.missingHolders ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Extra pairs</span><span class="count-value">{{
        report.totals?.extraHolders ?? 0 }}</span></div>
  </div>
  <p class="report-note">A role's views are a template snapshot taken when the role is assigned. "Missing" holders were
    assigned before the template gained pairs (re-assign the role or add the permission in Manage Users); "extra"
    holders were granted permissions by hand. Super admin is excluded.</p>
  <div class="report-table-container ac-table-region" role="region" aria-label="Roles" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Role</th>
          <th scope="col" class="num-col">Template pairs</th>
          <th scope="col" class="num-col">Holders</th>
          <th scope="col" class="num-col">Missing pairs</th>
          <th scope="col" class="num-col">Extra pairs</th>
        </tr>
      </thead>
      <tbody>
        @for(role of report.roles; track role.roleId){
        <tr [class.quiet-row]="!role.holders">
          <td class="text-col" data-label="Role"><span class="cell-title">{{ role.roleName }}</span> <span
              class="muted">{{ role.applicableFor | lowercase }}</span></td>
          <td class="num-col" data-label="Template pairs">{{ role.templatePairs }}</td>
          <td class="num-col" data-label="Holders">{{ role.holders }}</td>
          <td class="num-col" data-label="Missing pairs" [class.warn]="role.holdersMissing > 0">{{ role.holdersMissing
            }}</td>
          <td class="num-col" data-label="Extra pairs">{{ role.holdersExtra }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="5" class="empty-row">No roles.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  <h2 class="section-title">Drifted assignments</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Drifted assignments" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">User</th>
          <th scope="col" class="text-col">Role · place</th>
          <th scope="col" class="num-col">Missing</th>
          <th scope="col" class="num-col">Extra</th>
        </tr>
      </thead>
      <tbody>
        @for(a of report.assignments; track a.suremId){
        <tr>
          <td class="text-col" data-label="User">{{ a.fullName }} <span class="muted">{{ a.userName }}</span></td>
          <td class="text-col" data-label="Role · place">{{ a.roleName }} · {{ a.place }}</td>
          <td class="num-col" data-label="Missing" [class.warn]="a.missing > 0">{{ a.missing }}</td>
          <td class="num-col" data-label="Extra">{{ a.extra }}</td>
        </tr>
        } @empty { <tr>
          <td colspan="4" class="empty-row">No drift — every holder matches their role template.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  }
  <!-- ===== Media ===== -->
  @if(report && activeReport === 'media'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Media items</span><span class="count-value">{{
        report.totals?.items ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Active</span><span class="count-value">{{ report.totals?.active ??
        0 }}</span></div>
    <div class="count-card"><span class="count-label">Central</span><span class="count-value">{{ report.totals?.central
        ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Active but unused</span><span class="count-value">{{
        report.totals?.unused ?? 0 }}</span></div>
  </div>
  <p class="report-note">"Used" = the image URL is the preview image of an establishment utsav or the photo of a central
    utsav.</p>
  <div class="composition-grid">
    <div>
      <h2 class="section-title">By place and category</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Media by place and category"
        tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">Place</th>
              <th scope="col" class="text-col">Category</th>
              <th scope="col" class="num-col">Items</th>
              <th scope="col" class="num-col">Active</th>
              <th scope="col" class="num-col">Used</th>
            </tr>
          </thead>
          <tbody>
            @for(g of report.groups; track $index){
            <tr>
              <td class="text-col" data-label="Place">{{ g.place }}</td>
              <td class="text-col" data-label="Category">{{ g.category | titlecase }}</td>
              <td class="num-col" data-label="Items">{{ g.items }}</td>
              <td class="num-col" data-label="Active">{{ g.active }}</td>
              <td class="num-col" data-label="Used">{{ g.used }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="5" class="empty-row">No media yet.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <h2 class="section-title">Items</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Media items" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">Name</th>
              <th scope="col" class="text-col">Category · place</th>
              <th scope="col" class="num-col">Used by</th>
              <th scope="col" class="num-col">Status</th>
            </tr>
          </thead>
          <tbody>
            @for(m of report.rows; track m.mediaId){
            <tr [class.inactive]="!m.isActive">
              <td class="text-col" data-label="Name"><span class="cell-title">{{ m.name }}</span></td>
              <td class="text-col" data-label="Category · place">{{ m.category | titlecase }} · {{ m.place }}</td>
              <td class="num-col" data-label="Used by" [class.muted]="!m.usedBy">{{ m.usedBy }}</td>
              <td class="num-col" data-label="Status">{{ m.isActive ? 'Active' : 'Inactive' }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="4" class="empty-row">No media yet.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  }
  <!-- ===== Users & access ===== -->
  @if(report && activeReport === 'access'){
  <div class="stat-grid">
    <div class="count-card total"><span class="count-label">Users</span><span class="count-value">{{
        report.totals?.users ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Active</span><span class="count-value">{{ report.totals?.active ??
        0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.restricted ?? 0) > 0"><span
        class="count-label">Restricted</span><span class="count-value">{{ report.totals?.restricted ?? 0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.withoutRole ?? 0) > 0"><span class="count-label">Without a
        role</span><span class="count-value">{{ report.totals?.withoutRole ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">Super admins</span><span class="count-value">{{
        report.totals?.superAdmins ?? 0 }}</span></div>
    <div class="count-card"><span class="count-label">With extra permissions</span><span class="count-value">{{
        report.totals?.withExtras ?? 0 }}</span></div>
    <div class="count-card" [class.total]="(report.totals?.expiring ?? 0) > 0"><span class="count-label">Expiring ≤ 30
        days</span><span class="count-value">{{ report.totals?.expiring ?? 0 }}</span></div>
  </div>
  <h2 class="section-title">Users per role and place</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Users per role and place" tabindex="0">
    <table class="occupancy-table wide-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">Role</th>
          @for(p of report.places; track placeKey(p)){ <th scope="col" class="num-col">{{ p.name }}</th> }
          <th scope="col" class="num-col">Total</th>
        </tr>
      </thead>
      <tbody>
        @for(role of report.roles; track role.roleKey){
        <tr>
          <td class="text-col" data-label="Role"><span class="cell-title">{{ role.roleName }}</span> <span
              class="muted">{{ role.applicableFor | lowercase }} · {{ role.priority }}</span></td>
          @for(p of report.places; track placeKey(p)){
          <td class="num-col" [attr.data-label]="p.name" [class.muted]="!usersAt(role, p)">{{ usersAt(role, p) || '—' }}
          </td>
          }
          <td class="num-col" data-label="Total"><strong>{{ role.total }}</strong></td>
        </tr>
        } @empty {
        <tr>
          <td [attr.colspan]="(report.places?.length ?? 0) + 2" class="empty-row">No role assignments.</td>
        </tr>
        }
      </tbody>
    </table>
  </div>
  <div class="composition-grid">
    <div>
      <h2 class="section-title">Restricted users</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Restricted users" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">User</th>
              <th scope="col" class="text-col">Roles</th>
            </tr>
          </thead>
          <tbody>
            @for(u of report.restricted; track u.sumId){
            <tr>
              <td class="text-col" data-label="User">{{ u.fullName }} <span class="muted">{{ u.userName }}</span></td>
              <td class="text-col" data-label="Roles">{{ u.roles || '—' }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="2" class="empty-row">None.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <h2 class="section-title">Users without an active role</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Users without a role" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">User</th>
              <th scope="col" class="text-col">Username</th>
            </tr>
          </thead>
          <tbody>
            @for(u of report.withoutRole; track u.sumId){
            <tr>
              <td class="text-col" data-label="User">{{ u.fullName }}</td>
              <td class="text-col" data-label="Username">{{ u.userName }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="2" class="empty-row">None.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  <h2 class="section-title">Permissions added by hand (outside the role template)</h2>
  <div class="report-table-container ac-table-region" role="region" aria-label="Extra permissions" tabindex="0">
    <table class="occupancy-table ac-responsive-table">
      <thead>
        <tr>
          <th scope="col" class="text-col">User</th>
          <th scope="col" class="num-col">Extras</th>
          <th scope="col" class="num-col"></th>
        </tr>
      </thead>
      <tbody>
        @for(u of report.extras; track u.sumId){
        <tr>
          <td class="text-col" data-label="User">{{ u.fullName }} <span class="muted">{{ u.userName }}</span></td>
          <td class="num-col" data-label="Extras">{{ u.count }}</td>
          <td class="num-col"><button type="button" class="ac-secondary-small-btn rooms-btn"
              (click)="toggleUser(u.sumId)">{{ expandedUser === u.sumId ? 'Hide' : 'Show' }}</button></td>
        </tr>
        @if(expandedUser === u.sumId){
        <tr class="ac-detail-row">
          <td colspan="3">
            <div class="rooms-panel">
              @for(item of u.items; track $index){
              <div class="room-line">
                <span class="room-info">{{ item.viewLabel }} · <strong>{{ item.permission }}</strong></span>
                <span class="muted">{{ item.roleName }} · {{ item.place }}@if(item.validUntil){ · until {{
                  item.validUntil }}}</span>
              </div>
              }
            </div>
          </td>
        </tr>
        }
        } @empty { <tr>
          <td colspan="3" class="empty-row">None — everyone holds exactly their role templates.</td>
        </tr> }
      </tbody>
    </table>
  </div>
  <div class="composition-grid">
    <div>
      <h2 class="section-title">Permissions expiring within 30 days</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Expiring permissions" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">User</th>
              <th scope="col" class="text-col">Role · place</th>
              <th scope="col" class="num-col">Perms</th>
              <th scope="col" class="text-col">Earliest expiry</th>
            </tr>
          </thead>
          <tbody>
            @for(e of report.expiring; track $index){
            <tr>
              <td class="text-col" data-label="User">{{ e.fullName }}</td>
              <td class="text-col" data-label="Role · place">{{ e.roleName }} · {{ e.place }}</td>
              <td class="num-col" data-label="Perms">{{ e.permissions }}</td>
              <td class="text-col" data-label="Earliest expiry">{{ e.validUntil }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="4" class="empty-row">None.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
    <div>
      <h2 class="section-title">Inactivated role assignments</h2>
      <div class="report-table-container ac-table-region" role="region" aria-label="Inactive assignments" tabindex="0">
        <table class="occupancy-table ac-responsive-table">
          <thead>
            <tr>
              <th scope="col" class="text-col">User</th>
              <th scope="col" class="text-col">Role · place</th>
            </tr>
          </thead>
          <tbody>
            @for(a of report.inactiveAssignments; track $index){
            <tr>
              <td class="text-col" data-label="User">{{ a.fullName }} <span class="muted">{{ a.userName }}</span></td>
              <td class="text-col" data-label="Role · place">{{ a.roleName }} · {{ a.place }}</td>
            </tr>
            } @empty { <tr>
              <td colspan="2" class="empty-row">None.</td>
            </tr> }
          </tbody>
        </table>
      </div>
    </div>
  </div>
  }
</div>
<app-loader [isLoading]="isLoading"></app-loader>